/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Auction_ReviewInputs */

const cs_enum_auction_review = /** @type {(inputs: Enum_Auction_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znalecký posudek`)
};

const en_enum_auction_review = /** @type {(inputs: Enum_Auction_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auction review`)
};

/**
* | output |
* | --- |
* | "Auction review" |
*
* @param {Enum_Auction_ReviewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_auction_review = /** @type {((inputs?: Enum_Auction_ReviewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Auction_ReviewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_auction_review(inputs)
	return cs_enum_auction_review(inputs)
});